<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  actor?: string;
  reason?: string;
}

export interface ValidData {
  actor: string;
  reason: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});

const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.actor == null) return;
  if (formData.reason == null) return;

  emit('submit', event, {
    actor: formData.actor,
    reason: formData.reason,
  });
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    :class="$style.jobEditCancelJobDialogForm"
    validate-on="lazy"
    data-testid="jobEditCancelJobDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.actor"
      label="Actor"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
    />
    <KTextField
      v-model="formData.reason"
      label="Reason"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<style lang="scss" module>
.jobEditCancelJobDialogForm {
  display: contents;
}
</style>
